import { readonly, shallowRef } from 'vue'
import type { Ref } from 'vue'
import { isSameDay } from 'date-fns'

const REFRESH_MS = 60_000

const today = shallowRef(new Date())
const todayReadonly = readonly(today) as Readonly<Ref<Date>>
let started = false

/** Só reatribui quando o dia muda, para não recalcular as grades a cada minuto. */
export function refreshToday(): void {
  const now = new Date()
  if (!isSameDay(now, today.value)) today.value = now
}

/**
 * "Hoje" no relógio local do navegador, o mesmo da grade (`buildDayColumns`). Vira sozinho à
 * meia-noite com a tela aberta; o `visibilitychange` cobre a aba em segundo plano, onde o
 * navegador estrangula o intervalo.
 */
export function useToday(): { today: Readonly<Ref<Date>> } {
  if (!started) {
    started = true
    refreshToday()
    setInterval(refreshToday, REFRESH_MS)
    document.addEventListener('visibilitychange', refreshToday)
  }
  return { today: todayReadonly }
}
